export const successToast = (text) => {
  ToastShow(text,'success')
}
export const warnToast = (text) => {
  ToastShow(text,'warn')
}
export const errorToast = (text) => {
  ToastShow(text,'error')
}
export const tipToast = (text) => {
  ToastShow(text,'tip')
}
var timer;
export const ToastShow = (text, style) => {
  let existDom = document.getElementById('customizeToast')
  if (existDom) {
    document.body.removeChild(existDom);
  }
  const toast = document.createElement('span');
  const icon = document.createElement('div');
  const toastElement = document.createElement('div');
  const wrapper = document.createElement('div');
  wrapper.id = 'customizeToast'
  wrapper.style.position = 'fixed';
  wrapper.style.top = '0';
  wrapper.style.zIndex = '9999';

  wrapper.style.transition= "opacity 0.5s ease-in-out, transform 0.5s ease-in-out;";
  wrapper.style.display = "flex";
  wrapper.style.backgroundColor = "rgba(255,255,255,0)";
  wrapper.style.width = '100%';
  wrapper.style.pointerEvents = 'none';
  wrapper.style.justifyContent = 'center';
  wrapper.style.alignItems = 'center';
  toast.style.color = "#000";
  toast.innerText = text;
  toast.style.textAlign = "center";
  toast.style.fontSize = '12px';
  toast.style.textOverflow = 'ellipsis';
  toast.style.overflow = 'hidden';
  toast.style.whiteSpace = 'nowrap';

  var successIcon=`
  <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path fill="#00C869" d="M7,0 C10.8659932,-7.10171439e-16 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 4.73447626e-16,10.8659932 0,7 C-4.73447626e-16,3.13400675 3.13400675,7.10171439e-16 7,0 Z M9.75398652,4.57122729 L5.85720225,8.49405401 L5.85793701,8.49516372 L4.55778432,7.18644511 C4.40468396,7.02313848 4.17551271,6.95654977 3.95953772,7.0126167 C3.74356272,7.06868364 3.57493733,7.23854005 3.51934476,7.4560232 C3.46375219,7.67350634 3.52998361,7.90422438 3.69224046,8.05830768 L5.42443032,9.80240273 C5.66322638,10.04284 6.05117812,10.04284 6.28997418,9.80240273 L10.619163,5.44308987 C10.7831554,5.28945838 10.8507618,5.05793653 10.7954506,4.83938319 C10.7401395,4.62082985 10.5707362,4.45011742 10.3537217,4.39424059 C10.1367073,4.33836377 9.90670848,4.40623826 9.75398652,4.57122729 Z" id="形状结合"></path>
  </svg>
  `
  var errorIcon=`
  <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>形状</title>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="反推提示词" transform="translate(-2062.000000, -1069.000000)" fill="#F53F3F">
            <path fill="#F53F3F" d="M2069,1083 C2072.8661,1083 2076,1079.8661 2076,1076 C2076,1072.1346 2072.8661,1069 2069,1069 C2065.1339,1069 2062,1072.1346 2062,1076 C2062,1079.8661 2065.1339,1083 2069,1083 Z M2072.0149,1072.9851 C2072.2886,1073.2588 2072.2886,1073.7019 2072.0149,1073.9756 L2069.9898,1076 L2072.0149,1078.0251 C2072.2886,1078.2988 2072.2886,1078.7419 2072.0149,1079.0156 C2071.7419,1079.2886 2071.2981,1079.2886 2071.0251,1079.0156 L2069,1076.9905 L2066.9749,1079.0156 C2066.7019,1079.2886 2066.2581,1079.2886 2065.9851,1079.0156 C2065.7114,1078.7419 2065.7114,1078.2988 2065.9851,1078.0251 L2068.0102,1076 L2065.9851,1073.9756 C2065.7114,1073.7019 2065.7114,1073.2588 2065.9851,1072.9851 C2066.2581,1072.7121 2066.7019,1072.7121 2066.9749,1072.9851 L2069,1075.0102 L2071.0251,1072.9851 C2071.2981,1072.7121 2071.7419,1072.7121 2072.0149,1072.9851 Z" id="形状"></path>
        </g>
    </g>
</svg>
  `
  var warnIcon=`
  <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
     <path fill="#FF7D00" d="M7,0 C10.8659932,-7.10171439e-16 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 4.73447626e-16,10.8659932 0,7 C-4.73447626e-16,3.13400675 3.13400675,7.10171439e-16 7,0 Z M7.0063,9.6285 L6.9979,9.6285 C6.6115,9.6285 6.2979,9.9414 6.2979,10.3285 C6.2979,10.7149 6.6115,11.0285 6.9979,11.0285 L7.0063,11.0285 C7.3927,11.0285 7.7063,10.7149 7.7063,10.3285 C7.7063,9.9414 7.3927,9.6285 7.0063,9.6285 Z M7.0063,3.031 C6.6199,3.031 6.3063,3.3446 6.3063,3.731 L6.3063,3.731 L6.3069125,7.9907625 L6.3069125,7.9907625 L6.3091,8.0227 C6.3273,8.393 6.6332,8.6877 7.0084,8.6877 C7.3948,8.6877 7.7084,8.3748 7.7084,7.9877 L7.7084,7.9877 L7.7084,3.7604 C7.7084,3.7394 7.7077,3.7177 7.7056,3.6967 C7.6874,3.3264 7.3815,3.031 7.0063,3.031 Z" id="形状结合"></path>
  </svg>
  `
  var tipIcon = `
    <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>形状</title>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="反推提示词" transform="translate(-2062.000000, -1131.000000)" fill="#175DFF" fill-rule="nonzero">
            <path d="M2069,1145 C2065.13401,1145 2062,1141.86599 2062,1138 C2062,1134.13401 2065.13401,1131 2069,1131 C2072.86599,1131 2076,1134.13401 2076,1138 C2075.99566,1141.86419 2072.86419,1144.99566 2069,1145 Z M2069.84175,1136.15025 L2067.34362,1136.26662 L2067.383,1136.509 C2067.54924,1136.50472 2067.71554,1136.51497 2067.88,1136.53963 C2068.00593,1136.5637 2068.12527,1136.61441 2068.23,1136.68837 C2068.31962,1136.76591 2068.38317,1136.86918 2068.412,1136.98412 C2068.42698,1137.17432 2068.40255,1137.36555 2068.34025,1137.54588 L2067.61925,1140.2365 C2067.48564,1140.61808 2067.43493,1141.02377 2067.4705,1141.4265 C2067.5241,1141.67967 2067.65825,1141.90868 2067.85288,1142.07925 C2068.06837,1142.26988 2068.32641,1142.4061 2068.60538,1142.4765 C2068.77647,1142.52344 2068.95296,1142.54785 2069.13038,1142.54913 C2069.35549,1142.54987 2069.57823,1142.50305 2069.784,1142.41175 C2070.19499,1142.18863 2070.4999,1141.81065 2070.631,1141.36175 L2070.3055,1141.27425 C2070.21392,1141.52548 2070.05053,1141.74425 2069.83563,1141.90338 C2069.74243,1141.95306 2069.63849,1141.9792 2069.53287,1141.9795 C2069.47378,1141.97904 2069.41498,1141.97111 2069.35788,1141.95588 C2069.16763,1141.91649 2069.00153,1141.80154 2068.89763,1141.63738 C2068.80574,1141.38201 2068.81073,1141.10181 2068.91163,1140.84988 L2070.15062,1136.22725 L2069.84175,1136.14413 L2069.84175,1136.15025 Z M2069.483,1133.41413 C2069.18989,1133.41413 2068.92565,1133.59074 2068.81357,1133.86157 C2068.70148,1134.13241 2068.76362,1134.4441 2068.97101,1134.65123 C2069.1784,1134.85837 2069.49016,1134.92014 2069.76086,1134.80772 C2070.03156,1134.69531 2070.20785,1134.43086 2070.2075,1134.13775 C2070.20702,1133.73796 2069.88279,1133.41413 2069.483,1133.41413 L2069.483,1133.41413 Z" id="形状"></path>
        </g>
    </g>
</svg>
  `

  switch (style){
    case "success":
      toast.style.color = "#00C869";
      icon.innerHTML = successIcon;
      icon.style.margin = "0 0 0 0";
      break;
    case "warn":
      toast.style.color = "#FF7D00";
      icon.innerHTML = warnIcon;
      icon.style.margin = "0 0 0 0";
      break;
    case "error":
      toast.style.color = "#F53F3F";
      icon.innerHTML = errorIcon;
      icon.style.margin = "0 0 0 0";
      break;
    case "tip":
      toast.style.color = "#175DFF";
      icon.innerHTML = tipIcon;
      icon.style.margin = "0 0 0 0";
      break;
  }

  icon.style.width = '14px';
  icon.style.height = '14px';
  icon.style.display = 'flex'
  icon.style.marginRight = "9px";

  toastElement.style.display = "flex";
  toastElement.style.alignItems = 'center';
  toastElement.style.padding = "10px 15px";
  toastElement.style.boxShadow = "0 0 5px rgba(0, 0, 0, 0.2)";
  toastElement.style.borderRadius='4px';

  switch (style){
    case "success":
      toastElement.style.backgroundColor = "rgba(224, 248, 237, 1)";
      toastElement.style.border = "1px solid #E0F8ED"
      break;
    case "warn":
      toastElement.style.backgroundColor = "rgba(255, 239, 224, 1)";
      toastElement.style.border = "1px solid #FFEFE0"
      break;
    case "error":
      toastElement.style.backgroundColor = "rgba(254, 226, 226, 1)";
      toastElement.style.border = "1px solid #FEE2E2"
      break;
    case "tip":
      toastElement.style.backgroundColor = "rgba(224, 238, 255, 1)";
      toastElement.style.border = "1px solid #E0EEFF"
      break;
  }

  toastElement.appendChild(icon);
  toastElement.appendChild(toast);
  wrapper.appendChild(toastElement);
  document.body.appendChild(wrapper);
  // 动画函数
  const targetPosition = 50; // 目标位置
  let position = 0; // 当前移动位置
  const animate = () => {
    position += 2; // 每次移动1px
    wrapper.style.transform = `translateY(${position}px)`; // 竖直方向移动
    if (position < targetPosition) {
      requestAnimationFrame(animate); // 继续动画
    }
  };

  let hidePosition = 30
  let opacity = 1
  const hideAnimate = () => {
    hidePosition -= 2
    opacity -= 0.1
    wrapper.style.transform = `translateY(${hidePosition}px)`; // 竖直方向移动
    wrapper.style.opacity = String(opacity)
    if (hidePosition > 0) {
      requestAnimationFrame(hideAnimate); // 继续动画
    } else  {
      let exitsDom = document.getElementById('customizeToast')
      if (exitsDom) {
        document.body.removeChild(exitsDom);
      }
    }
  }
  animate(); // 开始动画
  clearTimeout(timer)
  timer = setTimeout(() => {
      hideAnimate()
    }, 3000);
}
